import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import messages from '../../../locale/jsonMessages';
import s from '../Inspection.css';

// Documents and equipment: the list comes from getChecklist (it evolves by country). The label of an item is the
// translation of its `labelKey`; an unknown key falls back on the readable item key so that nothing disappears.
export function ChecklistSection({ items, answers, onChange, disabled, intl, errorKey }) {
  const { formatMessage } = intl;
  const present = {};
  (answers || []).forEach((row) => { present[row.key] = Boolean(row.present); });
  const labelOf = (item) => {
    const message = item.labelKey ? messages[item.labelKey] : null;
    const translated = message && message.defaultMessage !== '[Key not found]' ? formatMessage(message) : null;
    return translated || String(item.key).replace(/_/g, ' ');
  };
  if (!items || !items.length) return <p className={s.cardHint}>{formatMessage(messages.inspChecklistEmpty)}</p>;
  return (
    <div>
      <ul className={s.checkList}>
        {items.map((item) => {
          const checked = Boolean(present[item.key]);
          const id = `inspection-check-${item.key}`;
          return (
            <li key={item.key} className={s.checkItem}>
              <label htmlFor={id} className={s.checkLabel}>
                <input
                  id={id}
                  type="checkbox"
                  className={s.checkBox}
                  checked={checked}
                  disabled={disabled}
                  onChange={(event) => onChange(item.key, event.target.checked)}
                />
                <span>{labelOf(item)}{item.required && <span className={s.required} aria-hidden="true"> *</span>}</span>
              </label>
              <span className={cx(s.presence, checked ? s.presenceYes : s.presenceNo)}>
                {formatMessage(checked ? messages.inspPresent : messages.inspAbsent)}
              </span>
            </li>
          );
        })}
      </ul>
      {errorKey && <p className={s.errorText} role="alert">{formatMessage(messages[errorKey])}</p>}
    </div>
  );
}

ChecklistSection.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string.isRequired, labelKey: PropTypes.string, required: PropTypes.bool })),
  answers: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string, present: PropTypes.bool })),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  errorKey: PropTypes.string
};
ChecklistSection.defaultProps = { items: [], answers: [], onChange: () => {}, disabled: false };

export default injectIntl(withStyles(s)(ChecklistSection));
